import { render, staticRenderFns } from "./LessonViewer.vue?vue&type=template&id=10dc5dad&scoped=true&"
import script from "./LessonViewer.vue?vue&type=script&lang=js&"
export * from "./LessonViewer.vue?vue&type=script&lang=js&"
import style0 from "./LessonViewer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LessonViewer.vue?vue&type=style&index=1&id=10dc5dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc5dad",
  null
  
)

export default component.exports